module.exports = __webpack_public_path__ + "static/img/2.3f36d7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/wechat/2.png
// module id = 8y1t
// module chunks = 1